import { render, staticRenderFns } from "./MyTour.vue?vue&type=template&id=f21dd848&"
import script from "./MyTour.vue?vue&type=script&lang=js&"
export * from "./MyTour.vue?vue&type=script&lang=js&"
import style0 from "./MyTour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports